import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  AppConstant,
  getContactModes,
  getCountryCode,
  ImageConstant,
  sendOtpApi,
  SEND_OTP_ACTION_TYPE,
  translate,
  useAppDispatch,
  useAppSelector,
  getContactModeLabelById,
  OTP_VERIFICATION_MEDIUM,
  getCurrentLanguageForWeb,
  getPreferredLanguagesList,
  LANGUAGE_UNIQUE_ID,
  registrationCode,
  ANALYTICS_PAGE_NAMES,
  logEvent,
  RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD,
  updateUserInput,
  updateCurrentStep,
  initializeSession,
  ERROR_TYPE,
  logError,
  PARTIAL_REGISTRATION_STATUSES,
  CUSTOM_ANALYTICS_EVENT_NAMES,
  PlatformNames,
  updateStatus,
  checkFields,
} from '@shalina-app/shared';
import { Checkbox, FormControlLabel, SelectChangeEvent } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { appInsights } from '../../../../applicationInsight';
import {
  ButtonComponent,
  CircularLoader,
  Dropdown,
  HyperLink,
  Input,
  MobileInput,
  Modal,
  RadioGroupComponent,
  Toast,
} from '../../../../components';
import styles from './signUp.module.scss';
import {
  capitalizeFirstLetter,
  countryCodeValidation,
  dropDownValidation,
  emailValidation,
  eventType,
  inputTextValidation,
  mobileStartZeroValidation,
  mobileValidation,
  radioGroupValidation,
  registrationCodeValidation,
  removedFromStore,
  retrieveData,
  STORAGE_CONSTANTS,
  storeData,
  useNavigatePageUtils,
} from '../../../../utils';
import { URLConstant } from '../../../../routes';
import { pageNames } from '../../../../app.constants';
import useSession from '../../hooks/useSession';
import useOfflineHandler from '../../hooks/useOfflineHandler';
import useAppLifecycleAndNetwork from '../../hooks/useAppLifecycleAndNetwork';

export const stripNumbering = (s: string) => s.replace(/^\d+\.\s*/, '');


export const SignUpPage: React.FC<any> = () => {
  const navigatePageUtils = useNavigatePageUtils();
  const { urls } = URLConstant;
  const t = translate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const statePathName = location?.state?.pathName;
  const rssContentData = location?.state?.rssContentData;

  const referralCode = location?.state?.referralCode || '';

  const localStorageLang = useAppSelector(getCurrentLanguageForWeb);
  // const localStorageLang = retrieveData(STORAGE_CONSTANTS.SELECTED_LANGUAGE);

  const countryList = useAppSelector(getCountryCode);
  const contactModes = useAppSelector(getContactModes);
  const authenticationLoading = useAppSelector(
    (state) => state?.authentication?.isLoading
  );
  // const commonLoading = useAppSelector((state) => state?.common?.isLoading);
  const languageList = useAppSelector(getPreferredLanguagesList);

  const preferredLanguagesList =
    languageList &&
    languageList.map((item: any) => ({
      label: item?.name,
      value: item?.tid,
      field_unique_code: item?.field_unique_code,
    }));
  // const mobileLength = useAppSelector(getMaxMobileLength);

  const [selectedCodeType, setSelectedCodeType] = useState('');
  const [selectedVerificationMedium, setSelectedVerificationMedium] =
    useState('');
  const [codeTextField, setCodeTextField] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [cityOrHospital, setCityOrHospital] = useState('');
  const [hospital, setHospital] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [emailId, setEmailId] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [nextCtaEnable, setNextCtaEnable] = useState(false);
  const [codeText, setCodeText] = useState('');
  const [termsCheck, setTermsCheck] = useState();
  const [countryCode, setCountryCode] = useState('');
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [isCodeInvalid, setIsCodeInvalid] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSubMessage, setToastSubMessage] = useState('');
  const [mobileLength, setMobileLength] = useState('');
  const [isRegistrationCodeDisabled, setIsRegistrationCodeDisabled] =
    useState(false);
  const [isRegistrationCodeLoading, setIsRegistrationCodeLoading] =
    useState(false);
  const [countryFlag, setCountryFlag] = useState('');
  const [isReferralFlow, setIsReferralFlow] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalCtaAction, setModalCtaAction] = useState('');
  const [partialData, setPartialData] = useState<any>({});
  const { sessionId, deviceId, resetSessionMetaData } = useSession();
  const { currentStep, userInputData, timestamp, errorLog } = useAppSelector(state => state.partialRegistration)
  const { hasGoneOffline, isNetworkPoor, savePartialData, restorePartialData, sendKPI } = useOfflineHandler(partialData, sessionId, deviceId);
  useAppLifecycleAndNetwork(partialData, sessionId, deviceId);

  useEffect(() => {
    window.scrollTo(0, 0);
    logEvent(appInsights, 'pageView', ANALYTICS_PAGE_NAMES.SIGN_UP);
    loadApi();
  }, []);

  React.useEffect(() => {
    // Initialize KPI with sessionId and deviceId
    dispatch(initializeSession({ sessionId: sessionId, deviceId: deviceId }));
  }, [sessionId, deviceId]);

  useEffect(() => {
    if (!hasGoneOffline && !isNetworkPoor && (sessionId && deviceId)) {
      restorePartialData().then((data) => {
        if (data) {
          sendKPI(sessionId, deviceId);
          if(!(mobileNumber || emailId)) {
            setPartialData({})
          }
        }
      });
    }
  }, [hasGoneOffline, isNetworkPoor, sessionId, deviceId]);

  useEffect(() => {
    if (contactModes && !selectedVerificationMedium) {
      const whatsAppDefault = contactModes?.find(
        (mode: { label: string; value: string }) =>
          mode?.label?.includes('Whatsapp')
      );
      setSelectedVerificationMedium(whatsAppDefault?.value);
    }
  }, [contactModes]);

  useEffect(() => {
    if (countryCode) {
      const country = countryList?.find(
        (item: any) => item?.value === countryCode
      );
      setMobileLength(country?.mobileLength);
      fetchRegistrationCode();
      setCountryFlag(country?.icons);
    }
  }, [countryList, countryCode]);

  useEffect(() => {
    if (selectedCodeType !== 'requestReferralCode') {
      fetchRegistrationCode();
    } else {
      setCodeText('');
    }
  }, [selectedCodeType]);

  useEffect(() => {
    if (languageList && languageList?.length > 0) {
      if (localStorageLang) {
        const currentLanguageSelected = languageList?.find(
          (lang: any) =>
            lang?.field_unique_code?.toLowerCase() ===
            localStorageLang?.toLowerCase()
        );
        setSelectedLanguage(currentLanguageSelected?.tid);
      } else {
        const defaultLanguage: any = languageList?.find(
          (item: any) => item?.field_unique_code === LANGUAGE_UNIQUE_ID?.ENGLISH
        );
        setSelectedLanguage(defaultLanguage?.tid);
      }
    }
  }, [languageList, localStorageLang]);

  const loadApi = async () => {
    // await dispatch(getCountryCodeList());
    // await dispatch(getPreferredLanguageList());
  };

  useEffect(() => {
    if (countryList && countryList?.length > 0) {
      const initialCountryCode = countryList?.[0]?.value;
      setCountryCode(initialCountryCode);
      storeData(STORAGE_CONSTANTS.COUNTRY_LIST, countryList);
    }
  }, [countryList]);

  useEffect(() => {
    if (referralCode) {
      setCodeText(referralCode);
      setCodeTextField(true);
      setSelectedCodeType('registrationCode');
      setIsCodeInvalid(false); // Resetting validation status
      setIsReferralFlow(true);
    } else {
      setIsReferralFlow(false);
    }
  }, []);

  const fetchRegistrationCode = async () => {
    // if (!RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD) {
    if (!referralCode && mobileNumber && emailId) {
      setIsRegistrationCodeLoading(true);
      const response = await dispatch(
        registrationCode({
          countryCode: countryCode,
          mobileNumber: mobileNumber,
          emailId: emailId,
        })
      );
      setIsRegistrationCodeLoading(false);
      if (response?.payload?.data?.registrationCode) {
        setCodeText(response?.payload?.data?.registrationCode);
        setIsCodeInvalid(false);
        setIsRegistrationCodeDisabled(true);
        setCodeTextField(true);
        setSelectedCodeType('registrationCode');
      } else if (selectedCodeType === 'requestReferralCode') {
        setCodeText('');
        setIsCodeInvalid(false);
        setIsRegistrationCodeDisabled(false);
        setCodeTextField(false);
      } else {
        setCodeText('');
        setIsCodeInvalid(false);
        setIsRegistrationCodeDisabled(false);
        // setCodeTextField(false);
        // setSelectedCodeType('');
      }
    }
    // }
  };

  const handleCodeTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const codeType = (event.target as HTMLInputElement).value;
    setSelectedCodeType(codeType);
    if (codeType === 'registrationCode') {
      setCodeTextField(true);
    } else {
      const settingRegistrationCode = isRegistrationCodeDisabled
        ? codeText
        : '';
      setCodeText(settingRegistrationCode);
      setIsCodeInvalid(false);
      setCodeTextField(false);
    }
  };

  const handleVerificationMediumChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const modeId = (event.target as HTMLInputElement).value;
    setSelectedVerificationMedium(modeId);
    const modeLabel = contactModes?.find((item: any) => item?.value === modeId)
    addPartialRegistrationData('verificationCode', modeLabel?.label ?? '')
  };

  const selectedModeLabel = useAppSelector(
    getContactModeLabelById(selectedVerificationMedium)
  );

  const handleNext = async () => {
    if(!navigator.onLine || isNetworkPoor){
      setShowToast(true)
      setModalOpen(false);
      setToastMessage('Network Issue. Your data is stored locally and will be restored on strong connectivity');
      savePartialData(partialData);
    }else{
    const req = {
      payload: {
        countryCode: countryCode,
        mobileNumber: mobileNumber,
        emailId: emailId,
        mode: selectedModeLabel?.toLowerCase(),
        registrationCode: codeText,
      },
      params: SEND_OTP_ACTION_TYPE.SIGN_UP_ACTION,
    };

    await requestOtp(req);
    }
  };

  const requestOtp = async (req: any) => {
    removedFromStore(STORAGE_CONSTANTS.USER_PARTIAL_REGISTRATION);
    try{
      const response: any = await dispatch(sendOtpApi(req)).unwrap();
      if (
        response &&
        response?.status === 'SUCCESS' &&
        response?.statusCode === 200
      ) {
        setShowToast(true);
        setIsSuccess(true);
        setToastMessage(t(response?.message));
        // setToastSubMessage("OTP was sent successfully");
        setNextCtaEnable(false);
  
        const navigateDetails = {
          stateParams: {
            pathName: statePathName,
            rssContentData: rssContentData,
            sourcePage: pageNames.SignUp,
            nextCta: t(AppConstant.AUTHENTICATION_PAGE.SIGN_UP_CTA),
            isReferral: isReferralFlow,
            formData: {
              firstName: firstName,
              lastName: lastName,
              cityOrHospital: cityOrHospital,
              hospital: hospital,
              mobile: mobileNumber,
              country: countryCode,
              email: emailId,
              mode: selectedModeLabel?.toLowerCase(),
              language: selectedLanguage,
              registrationCode: codeText,
              requestForReferralCode:
                selectedCodeType === 'requestReferralCode' || false,
              isTermsConditionAccepted: termsCheck || false,
              otpSent:
                selectedModeLabel?.toLowerCase() ===
                OTP_VERIFICATION_MEDIUM.EMAIL_VERIFICATION_MEDIUM
                  ? emailId
                  : `${countryCode} ${mobileNumber}`,
              partialData: partialData,
            },
          },
          isDynamicUrl: false,
        };
        await dispatch(updateStatus({status: PARTIAL_REGISTRATION_STATUSES.OTP_VERIFICATION_PENDING }))
        await logRegistrationFormSuccessKPI(mobileNumber, emailId, PARTIAL_REGISTRATION_STATUSES.OTP_VERIFICATION_PENDING, [])
        navigatePageUtils(urls.verificationPage, navigateDetails);
      } else {
        if (response && response?.response?.headers) {
          const contentType = response?.response?.headers["content-type"];
          if (contentType && contentType.includes("text/html")) {
            setIsSuccess(true);
            // setToastSubMessage("OTP was sent successfully");
            setNextCtaEnable(false);

            const navigateDetails = {
              stateParams: {
                pathName: statePathName,
                rssContentData: rssContentData,
                sourcePage: pageNames.SignUp,
                nextCta: t(AppConstant.AUTHENTICATION_PAGE.SIGN_UP_CTA),
                isReferral: isReferralFlow,
                formData: {
                  firstName: firstName,
                  lastName: lastName,
                  cityOrHospital: cityOrHospital,
                  hospital: hospital,
                  mobile: mobileNumber,
                  country: countryCode,
                  email: emailId,
                  mode: selectedModeLabel?.toLowerCase(),
                  language: selectedLanguage,
                  registrationCode: codeText,
                  requestForReferralCode:
                    selectedCodeType === "requestReferralCode" || false,
                  isTermsConditionAccepted: termsCheck || false,
                  otpSent:
                    selectedModeLabel?.toLowerCase() ===
                    OTP_VERIFICATION_MEDIUM.EMAIL_VERIFICATION_MEDIUM
                      ? emailId
                      : `${countryCode} ${mobileNumber}`,
                  partialData: partialData,
                },
              },
              isDynamicUrl: false,
            };
            await dispatch(
              updateStatus({
                status: PARTIAL_REGISTRATION_STATUSES.OTP_VERIFICATION_PENDING,
              })
            );
            await logRegistrationFormSuccessKPI(
              mobileNumber,
              emailId,
              PARTIAL_REGISTRATION_STATUSES.OTP_VERIFICATION_PENDING,
              {
                errorType: ERROR_TYPE.API_ERROR,
                message: response?.message || "OTP Send Failed",
              }
            );
            navigatePageUtils(urls.verificationPage, navigateDetails);
          }
        } else if (response?.message === "OTP_SEND_FAILED") {
          setIsSuccess(true);
          // setToastSubMessage("OTP was sent successfully");
          setNextCtaEnable(false);

          const navigateDetails = {
            stateParams: {
              pathName: statePathName,
              rssContentData: rssContentData,
              sourcePage: pageNames.SignUp,
              nextCta: t(AppConstant.AUTHENTICATION_PAGE.SIGN_UP_CTA),
              isReferral: isReferralFlow,
              formData: {
                firstName: firstName,
                lastName: lastName,
                cityOrHospital: cityOrHospital,
                hospital: hospital,
                mobile: mobileNumber,
                country: countryCode,
                email: emailId,
                mode: selectedModeLabel?.toLowerCase(),
                language: selectedLanguage,
                registrationCode: codeText,
                requestForReferralCode:
                  selectedCodeType === "requestReferralCode" || false,
                isTermsConditionAccepted: termsCheck || false,
                otpSent:
                  selectedModeLabel?.toLowerCase() ===
                  OTP_VERIFICATION_MEDIUM.EMAIL_VERIFICATION_MEDIUM
                    ? emailId
                    : `${countryCode} ${mobileNumber}`,
                partialData: partialData,
              },
            },
            isDynamicUrl: false,
          };
          await dispatch(
            updateStatus({
              status: PARTIAL_REGISTRATION_STATUSES.OTP_VERIFICATION_PENDING,
            })
          );
          await logRegistrationFormSuccessKPI(
            mobileNumber,
            emailId,
            PARTIAL_REGISTRATION_STATUSES.OTP_VERIFICATION_PENDING,
            {
              errorType: ERROR_TYPE.API_ERROR,
              message: response?.message || "OTP Send Failed",
            }
          );
          navigatePageUtils(urls.verificationPage, navigateDetails);
        } else if (response?.message === 'REGISTRATION_CODE_NOT_FOUND') {
            setIsCodeInvalid(true);
          }
          setNextCtaEnable(false);
          // setShowToast(true);
          // setIsSuccess(false);
          setModalOpen(true);
        if(response?.code === 'ECONNABORTED' && response?.name === 'AxiosError') {
          logErrorToSystem({
            errorType: ERROR_TYPE.API_TIMEOUT,
            message: response?.message || 'Request timed out',
          });
          setToastMessage('Request timed out. Please try again later')
          return false;
        }else if(response?.name === 'AxiosError' && response?.response?.status >= 500) {
          logErrorToSystem({
            errorType: ERROR_TYPE.SERVER_ERROR,
            message: response?.message || 'Server Error Occurred',
          });
          setToastMessage(response?.message || 'Server Error Occurred')
          return false;
        }else if(response && response?.status === 'ERROR' && response?.statusCode === 403 && response?.message === 'USER_BLOCKED') {
          setToastMessage(t(AppConstant.ERROR.ACCOUNT_BLOCKED_MESSAGE))
          setModalCtaAction('Okay')
        }else{
          if(response?.message === undefined) {
            setShowToast(true)
            setModalOpen(false);
            setToastMessage('Network Issue. Your data is stored locally and will be restored on strong connectivity');
            savePartialData(partialData);
          }else{
            setToastMessage(t(response?.message));
            setModalCtaAction('')
          } 
        }
        // setToastMessage("OTP Sent Failed!");
        // setToastSubMessage("Please check your credentials and try again.");
      }
    }catch(error: any) {
      // Handle errors like timeout errors and server errors etc.
      if (error?.code === 'ECONNABORTED') {
        // Handle timeout error specifically
        logErrorToSystem({
          errorType: ERROR_TYPE.API_TIMEOUT,
          message: error.message || 'Request timed out',
        });
        setToastMessage(error?.message);
        return false;
      }else if (error?.response) {
        const { status, data } = error.response;

        if (status >= 500) {
          // Handle server error specifically
          logErrorToSystem({
            errorType: ERROR_TYPE.SERVER_ERROR,
            message: error.message || 'Server Error Occurred',
          });
        }
      }
    }
  }

  const logErrorToSystem = async (errorDetails: any) => {
    const errorLog = {
      ...errorDetails,
      timestamp: new Date().toISOString(),
      sessionId,
      deviceId,
    };    
    // Log to Redux
    dispatch(logError(errorLog));
  
    // Save to Azure KPI
    if(navigator.onLine) {
      await logRegistrationFormSuccessKPI(mobileNumber, emailId, PARTIAL_REGISTRATION_STATUSES.REGISTRATION_INCOMPLETE, errorLog)
      await resetSessionMetaData();
    }
    // Save to AsyncStorage
    const existingLogs = JSON.parse(retrieveData(STORAGE_CONSTANTS.ERROR_LOGS)) || [];
    existingLogs.push(errorLog);
    storeData(STORAGE_CONSTANTS.ERROR_LOGS, JSON.stringify(existingLogs));
  };

  const logRegistrationFormSuccessKPI = (mobileNumber: string, email: string, status: string, errorLog: any) => {
    appInsights.trackEvent(
      { name: CUSTOM_ANALYTICS_EVENT_NAMES.USER_PARTIAL_REGISTRATION },
      {
        userEmail: email,
        userMobile: mobileNumber,
        sessionId: sessionId,
        deviceId: deviceId,
        userInputData: userInputData,
        status: status,
        errorLog: errorLog || [],
        currentStep: currentStep,
        platform: PlatformNames.WEB,
        timestamp: new Date().toISOString(),
      }
    );
  }

  const handleToastClose = () => {
    setShowToast(false);
  };

  const switchToSignIn = async () => {
    await savePartialData(partialData);
    if(partialData && checkFields(partialData)){
      await removedFromStore(STORAGE_CONSTANTS.USER_PARTIAL_REGISTRATION)
      await logErrorToSystem({
        errorType: ERROR_TYPE.IN_APP_DISENGAGEMENT,
        message: 'User has disengaged and navigated to Login page',
      })
    }
    const navigateDetails = {
      isDynamicUrl: false,
      stateParams: {
        pathName: statePathName,
        rssContentData: rssContentData,
      },
    };
    navigatePageUtils(urls.signInPage, navigateDetails);
  };

  const handleTermAction = () => {
    setTermsModalOpen(true);
  };

  const handleTermsModalClose = () => {
    setTermsModalOpen(false);
  };

  const verificationCodeObj = [
    {
      label: t(
        AppConstant.AUTHENTICATION_PAGE
          .VERIFICATION_CODE_MEDIUM_REGISTRATION_TEXT
      ),
      value: 'registrationCode',
    },
    // {
    //   label: t(
    //     AppConstant.AUTHENTICATION_PAGE.VERIFICATION_CODE_MEDIUM_REFERRAL_TEXT),
    //   value: "referralCode",
    // },
    {
      label: t(
        AppConstant.AUTHENTICATION_PAGE
          .VERIFICATION_CODE_MEDIUM_REQUEST_REFERRAL_TEXT
      ),
      value: 'requestReferralCode',
    },
  ];

  const codeFieldValidation = () => {
    let validated = false;
    if (selectedCodeType === 'registrationCode') {
      if (codeText && codeText?.trim()?.length > 0) {
        validated = true;
      }
    } else if (selectedCodeType === 'requestReferralCode') {
      validated = true;
    }

    return validated;
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const checkCondition = () => {
    if (
      firstName &&
      !inputTextValidation(firstName) &&
      lastName &&
      !inputTextValidation(lastName) &&
      emailId &&
      !emailValidation(emailId) &&
      mobileNumber &&
      !mobileValidation(mobileNumber, mobileLength) &&
      !mobileStartZeroValidation(mobileNumber) &&
      cityOrHospital &&
      !inputTextValidation(cityOrHospital) &&
      countryCode &&
      !countryCodeValidation(countryCode) &&
      selectedVerificationMedium &&
      !radioGroupValidation(selectedVerificationMedium) &&
      termsCheck
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD) {
      if (checkCondition()) {
        setNextCtaEnable(true);
      } else {
        setNextCtaEnable(false);
      }
    } else {
      if (checkCondition() && selectedCodeType && codeFieldValidation()) {
        setNextCtaEnable(true);
      } else {
        setNextCtaEnable(false);
      }
    }
  }, [
    firstName,
    lastName,
    emailId,
    mobileNumber,
    countryCode,
    selectedCodeType,
    codeText,
    selectedVerificationMedium,
    termsCheck,
    cityOrHospital
  ]);

  const onLogoClick = async () => {
    await savePartialData(partialData);
    if(partialData && checkFields(partialData)){
      await removedFromStore(STORAGE_CONSTANTS.USER_PARTIAL_REGISTRATION)
      await logErrorToSystem({
        errorType: ERROR_TYPE.IN_APP_DISENGAGEMENT,
        message: 'User has disengaged and navigated to home page',
      })
    }
    const navigateDetails = {
      isDynamicUrl: false,
    };
    navigatePageUtils(urls.homePage, navigateDetails);
  };

  const handleHelpSupport = async () => {
    await savePartialData(partialData);
    if(partialData && checkFields(partialData)){
      await removedFromStore(STORAGE_CONSTANTS.USER_PARTIAL_REGISTRATION)
      await logErrorToSystem({
        errorType: ERROR_TYPE.IN_APP_DISENGAGEMENT,
        message: 'User has disengaged and navigated to help & support',
      })
    }
    const navigateDetails = {
      isDynamicUrl: false,
    };
    navigatePageUtils(urls.helpSupport, navigateDetails);
  };

  const handleCodeChange = (value: string) => {
    setCodeText(value);
    setIsCodeInvalid(false);
  };

  const handleCountryCodeChange = async (value: any) => {
    addPartialRegistrationData('countryCode', value)
    setCountryCode(value);
  };
  const { AuthenticationBgIcon } = ImageConstant.SVG_ICONS;

  const onModalCtaPress = async () => {
    setModalOpen(false)
    setToastMessage('')
    setModalCtaAction('')
    await savePartialData(partialData);
    if(partialData && checkFields(partialData)){
      await removedFromStore(STORAGE_CONSTANTS.USER_PARTIAL_REGISTRATION)
      await logErrorToSystem({
        errorType: ERROR_TYPE.IN_APP_DISENGAGEMENT,
        message: 'User has disengaged and navigated to help & support',
      })
    }
    const navigateDetails = {
      isDynamicUrl: false,
    };
    navigatePageUtils(urls.helpSupport, navigateDetails);
  }

  const addPartialRegistrationData = (field: string, value: string) => {
    const updatedData = { ...partialData, [field]: value };
    setPartialData({...updatedData, currentStep: field});
    dispatch(updateUserInput({ [field]: value }));
    dispatch(updateCurrentStep({step: field}));
  }

  console.log('partial data is ', partialData);
  return (
    <>
      <div className={styles.signUpWrapper}>
        <div className={styles.authBg}>
          <AuthenticationBgIcon />
        </div>
        <div className="cust-container">
          <div className={styles.signUplogo}>
            <img
              src={ImageConstant.SOURCE.ShalinaMedspaceLogo}
              alt="logo"
              className={styles.logo}
              onClick={onLogoClick}
            />
            <div className={styles.signInTop}>
              <span>
                {t(AppConstant.AUTHENTICATION_PAGE.ALREADY_HAVE_ACCOUNT_TEXT)}
              </span>
              <HyperLink
                handleClick={switchToSignIn}
                hyperText={t(AppConstant.AUTHENTICATION_PAGE.SIGN_IN_CTA)}
                disabled={false}
              />
            </div>
          </div>
        </div>

        <div className={styles.signupContainer}>
          <h4 className={styles.title}>
            {t(AppConstant.AUTHENTICATION_PAGE.SIGN_UP_FORM_WEB_HEADING)}
          </h4>
          <div className={styles.signupForm}>
            <div className={styles.signupFormCol}>
              <Dropdown
                defaultValue=""
                value={selectedLanguage}
                dropdownId="grouped-select"
                dropdownVariant="outlined"
                labelText={t(
                  AppConstant.AUTHENTICATION_PAGE.PREFERRED_LANGUAGE
                )}
                dropdownOptions={preferredLanguagesList}
                isError={dropDownValidation(selectedLanguage)}
                errorMessage={t(AppConstant.ERROR.ENTER_VALID_PREFFERED_LANG)}
                handleDropDownChange={async (e: SelectChangeEvent) => {
                  addPartialRegistrationData(
                    "preferredLanguage",
                    e.target.value
                  );
                  setSelectedLanguage(e.target.value || "");
                }}
                placeholder=""
                isLanguage={true}
              />
            </div>
          </div>
          <div className={styles.signupForm}>
            <div className={styles.signupFormCol}>
              <Input
                placeHolderText={t(AppConstant.PROFILE.ENTER_FIRST_NAME)}
                formControlVariant={"standard"}
                labelText={t(AppConstant.AUTHENTICATION_PAGE.FIRST_NAME_TEXT)}
                inputId={"firstName"}
                inputVariant={"outlined"}
                isRequired={true}
                value={firstName}
                isError={inputTextValidation(firstName)}
                errorMessage={t(AppConstant.ERROR.ENTER_VALID_FIRST_NAME)}
                handleChange={(e: eventType) =>
                  setFirstName(capitalizeFirstLetter(e.target.value))
                }
                handleOnBlur={() =>
                  addPartialRegistrationData("firstName", firstName)
                }
              />
            </div>
            <div className={styles.signupFormCol}>
              <Input
                placeHolderText={t(AppConstant.PROFILE.ENTER_LAST_NAME)}
                formControlVariant={"standard"}
                labelText={t(AppConstant.AUTHENTICATION_PAGE.LAST_NAME_TEXT)}
                inputId={"lastName"}
                inputVariant={"outlined"}
                isRequired={true}
                value={lastName}
                isError={inputTextValidation(lastName)}
                errorMessage={t(AppConstant.ERROR.ENTER_VALID_LAST_NAME)}
                handleChange={(e: eventType) =>
                  setLastName(capitalizeFirstLetter(e.target.value))
                }
                handleOnBlur={() =>
                  addPartialRegistrationData("lastName", lastName)
                }
              />
            </div>
            <div className={styles.signupFormCol}>
              <MobileInput
                placeHolderText={t(AppConstant.PROFILE.ENTER_MOBILE_NUMBER)}
                defaultCountryCode={countryCode}
                countryValue={countryCode}
                formControlVariant="standard"
                labelText={t(
                  AppConstant.AUTHENTICATION_PAGE.MOBILE_NUMBER_TEXT
                )}
                inputId="mobileNumbar"
                inputVariant="outlined"
                isRequired={true}
                dropdownVariant="outlined"
                dropdownOptions={countryList}
                isError={
                  mobileStartZeroValidation(mobileNumber) ||
                  mobileValidation(mobileNumber, mobileLength)
                }
                countryCodeError={countryCodeValidation(countryCode)}
                errorMessage={
                  mobileStartZeroValidation(mobileNumber)
                    ? t(AppConstant.ERROR.MOBILE_VALIDATION_FOR_START_ZERO)
                    : t(AppConstant.ERROR.ENTER_VALID_MOBILE)
                }
                handleChange={(e: eventType) => setMobileNumber(e.target.value)}
                handleOnBlur={() => {
                  addPartialRegistrationData("mobileNumber", mobileNumber);
                  fetchRegistrationCode();
                }}
                handleCountryCodeChange={(e: any) => {
                  mobileStartZeroValidation(mobileNumber);
                  mobileValidation(mobileNumber, mobileLength);
                  handleCountryCodeChange(e.target.value);
                }}
                maxMobileLength={mobileLength}
                countryFlag={countryFlag}
              />
            </div>
            <div className={styles.signupFormCol}>
              <Input
                placeHolderText={t(AppConstant.PROFILE.ENTER_YOUR_EMAIL)}
                formControlVariant={"standard"}
                labelText={t(AppConstant.AUTHENTICATION_PAGE.EMAIL_TEXT)}
                inputId={"email"}
                inputVariant={"outlined"}
                isRequired={true}
                isError={emailValidation(emailId)}
                errorMessage={t(AppConstant.ERROR.ENTER_VALID_EMAIL)}
                handleChange={(e: eventType) => setEmailId(e.target.value)}
                handleOnBlur={() => {
                  addPartialRegistrationData("email", emailId);
                  fetchRegistrationCode();
                }}
              />
            </div>
            <div className={styles.signupFormCol}>
              <Input
                placeHolderText={t(
                  AppConstant.COMMON.ENTER_CITY_HOSPITAL_FIELD
                )}
                formControlVariant={"standard"}
                labelText={t(AppConstant.COMMON.CITY_HOSPITAL_FIELD)}
                inputId={"cityOrHospital"}
                inputVariant={"outlined"}
                isRequired={true}
                value={cityOrHospital}
                isError={inputTextValidation(cityOrHospital)}
                errorMessage={t(AppConstant.ERROR.ENTER_VALID_CITY_HOSPITAL)}
                handleChange={(e: eventType) =>
                  setCityOrHospital(capitalizeFirstLetter(e.target.value))
                }
                handleOnBlur={() =>
                  addPartialRegistrationData("cityOrHospital", cityOrHospital)
                }
              />
            </div>
            <div className={styles.signupFormCol}>
              <Input
                placeHolderText={t(AppConstant.COMMON.ENTER_HOSPITAL_FIELD)}
                formControlVariant={"standard"}
                labelText={t(AppConstant.COMMON.HOSPITAL_FIELD)}
                inputId={"hospital"}
                inputVariant={"outlined"}
                isRequired={false}
                value={hospital}
                isError={false}
                errorMessage={""}
                handleChange={(e: eventType) =>
                  setHospital(capitalizeFirstLetter(e.target.value))
                }
                handleOnBlur={() =>
                  addPartialRegistrationData("hospital", hospital)
                }
              />
            </div>
            {!RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD && (
              <div className={styles.signupFormCol12}>
                <RadioGroupComponent
                  formControlVariant={"standard"}
                  labelText={t(AppConstant.AUTHENTICATION_PAGE.I_HAVE_TEXT)}
                  inputId={"verificationCode"}
                  isRequired={true}
                  radioGroupObj={verificationCodeObj}
                  selectedValue={selectedCodeType}
                  handleRadioChange={handleCodeTypeChange}
                  isError={radioGroupValidation(selectedCodeType)}
                  errorMessage={t(AppConstant.ERROR.ENTER_VALID_OPTION)}
                />
                {codeTextField && (
                  <div className={styles.registrationDiv}>
                    <Input
                      placeHolderText={t(
                        AppConstant.PROFILE.ENTER_VALID_REGISTRATION_CODE
                      )}
                      formControlVariant={"standard"}
                      value={codeText}
                      labelText={""}
                      inputId={"codeText"}
                      inputVariant={"outlined"}
                      isRequired={false}
                      isError={
                        isCodeInvalid || registrationCodeValidation(codeText)
                      }
                      disabled={isRegistrationCodeDisabled}
                      errorMessage={t(AppConstant.ERROR.ENTER_VALID_CODE)}
                      handleChange={(e: eventType) => {
                        addPartialRegistrationData(
                          "registrationCode",
                          codeText
                        );
                        handleCodeChange(e.target.value);
                      }}
                    />
                    {isRegistrationCodeLoading && (
                      <span className={styles.registrationLoader}>
                        <CircularProgress
                          size={20}
                          thickness={4}
                          sx={{
                            color: "var(--secondaryOrange)",
                          }}
                        />
                      </span>
                    )}
                  </div>
                  // <input type="text" className={styles.referralCodeInput} />
                )}
              </div>
            )}
            <div className={styles.signupFormCol12}>
              <RadioGroupComponent
                formControlVariant={"standard"}
                labelText={t(
                  AppConstant.AUTHENTICATION_PAGE.GET_VERIFICATION_CODE_ON_TEXT
                )}
                inputId={"verificationCode"}
                isRequired={true}
                radioGroupObj={contactModes}
                selectedValue={selectedVerificationMedium}
                handleRadioChange={handleVerificationMediumChange}
                isError={radioGroupValidation(selectedModeLabel?.toLowerCase())}
                errorMessage={t(AppConstant.ERROR.ENTER_VALID_MODE)}
              />
            </div>
            <div className={styles.signupFormCol12}>
              <div className={styles.termCheck}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(event: any) => {
                        addPartialRegistrationData(
                          "termsAndConditionChecked",
                          event.target?.checked
                        );
                        setTermsCheck(event.target?.checked);
                      }}
                    />
                  }
                  label=""
                />
                <div className={styles.termText}>
                  {t(
                    AppConstant.AUTHENTICATION_PAGE
                      .TERMS_AND_CONDITION_CONCENT_PART1
                  )}
                  <HyperLink
                    handleClick={handleTermAction}
                    hyperText={t(
                      AppConstant.AUTHENTICATION_PAGE
                        .TERMS_AND_CONDITION_CONCENT_PART2
                    )}
                    disabled={false}
                  />
                  {t(
                    AppConstant.AUTHENTICATION_PAGE
                      .TERMS_AND_CONDITION_CONCENT_PART3
                  )}
                </div>
                {termsCheck === false && (
                  <p className={styles.checkError}>
                    {t(
                      AppConstant.AUTHENTICATION_PAGE
                        .TERMS_CONDITIONS_VALIDATION_TEXT
                    )}
                  </p>
                )}
              </div>
            </div>

            <div className={styles.signupCta}>
              <ButtonComponent
                variant="outlined"
                buttonText={t(AppConstant.AUTHENTICATION_PAGE.SIGN_UP_CTA)}
                onPress={handleNext}
                disabled={!nextCtaEnable}
              />
            </div>

            {/* <div className={styles.signupFormCol12}>
              <div className={styles.divider}>
                <HorizontalDivider />
              </div>
            </div>  */}
            <div className={styles.toggleLogin}>
              <span>{t(AppConstant.COMMON.FACING_ISSUE_TEXT)}</span>
              <HyperLink
                handleClick={handleHelpSupport}
                hyperText={t(AppConstant.HEADER.HELP_SUPPORT_MENU)}
                disabled={false}
              />
            </div>
          </div>
        </div>
        {termsModalOpen && (
          <Modal
            modalOpen={termsModalOpen}
            handleModalClose={handleTermsModalClose}
            className="termsModal"
          >
            <div className={styles.termsModalHead}>
              <h4 className={styles.title}>
                {t(AppConstant.TERMS_AND_CONDITIONS.TERMS_CONDITIONS)}
              </h4>
              <span className={styles.closeCta} onClick={handleTermsModalClose}>
                &times;
              </span>
            </div>

            <div className={styles.termsContent}>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.OVERVIEW)}
                </h4>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.OVERVIEW_ONE)}</p>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.OVERVIEW_TWO)}</p>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.OVERVIEW_THREE)}</p>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.CHANGES_TO_TERMS_OF_USE)}
                </h4>
                <p>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS.CHANGES_TO_TERMS_OF_USE_ONE
                  )}
                </p>
                <p>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS.CHANGES_TO_TERMS_OF_USE_TWO
                  )}
                </p>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES)}
                </h4>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_ONE)}</p>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_TWO)}</p>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_THREE)}
                </p>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_FOUR)}
                </p>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_FIVE)}
                </p>

                <p>{t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST)}</p>
                <ol>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_ONE)
                    )}
                  </li>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_TWO)
                    )}
                  </li>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_THREE)
                    )}
                  </li>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_FOUR)
                    )}
                  </li>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_FIVE)
                    )}
                  </li>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_SIX)
                    )}
                  </li>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_SEVEN)
                    )}
                  </li>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_EIGHT)
                    )}
                  </li>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_NINE)
                    )}
                  </li>
                  <li>
                    {stripNumbering(
                      t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_TEN)
                    )}
                  </li>
                </ol>

                <p>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION)}</p>
                <ol>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION_ONE)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION_TWO)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION_THREE)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION_FOUR)}</li>
                </ol>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.COPYRIGHT_NOTICE)}
                </h4>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.COPYRIGHT_NOTICE_ONE)}
                </p>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.COPYRIGHT_NOTICE_TWO)}
                </p>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.COPYRIGHT_NOTICE_THREE)}
                </p>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_INFORMATION)}
                </h4>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_INFORMATION_TEXT)}
                </p>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.MEDICAL_INFORMATION)}
                </h4>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.MEDICAL_INFORMATION_TEXT)}
                </p>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.VIDEO_DISCLAIMER)}
                </h4>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.VIDEO_DISCLAIMER_TEXT)}
                </p>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS
                      .INFORMATION_CAPTURED_THROUGH_THE_SERVICES
                  )}
                </h4>
                <p>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS
                      .INFORMATION_CAPTURED_THROUGH_THE_SERVICES_TEXT
                  )}
                </p>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.PURPOSE_CHECKLIST)}</p>
                <ul>
                  <li>
                    {t(AppConstant.TERMS_AND_CONDITIONS.PURPOSE_CHECKLIST_ONE)}
                  </li>
                  <li>
                    {t(AppConstant.TERMS_AND_CONDITIONS.PURPOSE_CHECKLIST_TWO)}
                  </li>
                  <li>
                    {t(
                      AppConstant.TERMS_AND_CONDITIONS.PURPOSE_CHECKLIST_THREE
                    )}
                  </li>
                </ul>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.CONSENT)}
                </h4>
                <ul>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_ONE)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_TWO)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_THREE)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_FOUR)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_FIVE)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_SIX)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_SEVEN)}</li>
                  <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_EIGHT)}</li>
                </ul>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.PRIVACY_POLICY)}
                </h4>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.PRIVACY_POLICY_TEXT)}</p>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS
                      .LAWS_THAT_GOVERN_THIS_AGREEMENT
                  )}
                </h4>
                <p>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS
                      .LAWS_THAT_GOVERN_THIS_AGREEMENT_TEXT
                  )}
                </p>
              </div>
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS
                      .TERMINATION_AND_MODIFICATION
                  )}
                </h4>
                <p>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS
                      .TERMINATION_AND_MODIFICATION_TEXT
                  )}
                </p>
                <ul>
                  <li>
                    {t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_ONE)}
                  </li>
                  <li>
                    {t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_TWO)}
                  </li>
                  <li>
                    {t(
                      AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_THREE
                    )}
                  </li>
                  <li>
                    {t(
                      AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_FOUR
                    )}
                  </li>
                  <li>
                    {t(
                      AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_FIVE
                    )}
                  </li>
                  <li>
                    {t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_SIX)}
                  </li>
                </ul>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_CONSENT)}</p>
              </div>
              {/* —————————————— Liability, Warranty, Indemnity, Accept & Amend —————————————— */}
              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.LIABILITY)}
                </h4>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.LIABILITY_TEXT_ONE)}</p>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.LIABILITY_TEXT_TWO)}</p>
              </div>

              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.WARRANTY_DISCLAIMER)}
                </h4>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.WARRANTY_DISCLAIMER_ONE)}
                </p>
                <p>
                  {t(AppConstant.TERMS_AND_CONDITIONS.WARRANTY_DISCLAIMER_TWO)}
                </p>
              </div>

              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.INDEMNITY)}
                </h4>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.INDEMNITY_TEXT)}</p>
              </div>

              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.ACCEPT_TERMS_OF_SERVICE)}
                </h4>
                <p>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS
                      .ACCEPT_TERMS_OF_SERVICE_TEXT
                  )}
                </p>
              </div>

              <div className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS.AMMENDMENT_OF_TERMS_OF_USE
                  )}
                </h4>
                <p>
                  {t(
                    AppConstant.TERMS_AND_CONDITIONS
                      .AMMENDMENT_OF_TERMS_OF_USE_TEXT
                  )}
                </p>
              </div>
            </div>
          </Modal>
        )}
        {authenticationLoading && <CircularLoader size={50} thickness={4} />}
        <Toast
          showToast={showToast}
          isSuccess={isSuccess}
          message={toastMessage}
          subMessage={toastSubMessage}
          handleToastClose={handleToastClose}
        />

        <Modal modalOpen={modalOpen} handleModalClose={handleModalClose}>
          <div className={styles.modalWrap}>
            <h2 className={styles.title}>{t(AppConstant.ERROR.ERROR_TEXT)}</h2>
            <button onClick={handleModalClose} className={styles.closeCta}>
              &times;
            </button>
            <span>{toastMessage}</span>
            {modalCtaAction && modalCtaAction !== "" && (
              <div className={styles.modalCtaWrap}>
                <button onClick={onModalCtaPress}>{modalCtaAction}</button>
              </div>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};
